// extracted by mini-css-extract-plugin
export var bgBeige = "styles-module--bgBeige--30c10";
export var hl = "styles-module--hl--6a25f";
export var hlWrapper = "styles-module--hlWrapper--b89c0";
export var linkWrapper = "styles-module--linkWrapper--9f26f";
export var relative = "styles-module--relative--80c13";
export var wrapper = "styles-module--wrapper--3bf8e";